import { useEffect, useState } from 'react';
import { storeService } from '../services/storeService';
import { StoreBanner } from '../models';

export function useBanners() {
  const [banners, setBanners] = useState<StoreBanner[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let active = true;
    setIsLoading(true);
    setError(null);

    storeService
      .getBanners()
      .then((data) => {
        if (active) setBanners(data);
      })
      .catch((err) => {
        if (active) setError(err instanceof Error ? err : new Error('Erro ao carregar banners'));
      })
      .finally(() => {
        if (active) setIsLoading(false);
      });

    return () => {
      active = false;
    };
  }, []);

  return { banners, isLoading, error, isEmpty: banners.length === 0 };
}
